import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  onClick,
  href = 'Link de tu checkout',
  ...props
}: ButtonProps) {
  return <a href={href} onClick={onClick} className={`
        inline-flex items-center justify-center 
        bg-[#d4a017] hover:bg-[#e5b229] 
        text-[#1e3a5f] font-extrabold text-lg md:text-xl
        py-4 px-8 rounded-xl shadow-[0_4px_14px_0_rgba(212,160,23,0.39)]
        transform transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_6px_20px_rgba(212,160,23,0.23)]
        text-center
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-31">
      {children}
    </a>;
}